export const SET_SHOW_FULL_SCREEN_LOADER = 'SET_SHOW_FULL_SCREEN_LOADER'
export const SET_SHOW_FADE_FS = 'SET_SHOW_FADE_FS'
export const SHOW_ALERT = 'SHOW_ALERT'
export const HIDE_ALERT = 'HIDE_ALERT'
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
export const HIDE_NOTIFICATIONS = 'HIDE_NOTIFICATIONS'
export const HIDE_HEADER = 'HIDE_HEADER'
export const SHOW_HEADER = 'SHOW_HEADER'
